(function () {
  function getInitialGender() {
    var params = new URLSearchParams(window.location.search);
    var genreParam = params.get('genre');
    if (genreParam === 'femme' || genreParam === 'homme') return genreParam;

    var current = document.documentElement.getAttribute('data-guide-genre');
    if (current === 'femme' || current === 'homme') return current;

    return 'homme';
  }

  function updateActiveStates() {
    document.querySelectorAll('.guide-des-tailles-toggle__option').forEach(function (option) {
      var input = option.querySelector('input[type="radio"]');
      option.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function syncToggleGroup(container, gender) {
    if (!container) return;

    container.querySelectorAll('input[type="radio"]').forEach(function (input) {
      input.checked = input.value === gender;
    });
  }

  function refreshGuideAnimations() {
    document.querySelectorAll('.template-page.suffix-guide-des-tailles [data-aos]').forEach(function (el) {
      el.classList.add('aos-animate');
    });

    if (window.AOS && typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    } else if (window.AOS && typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
    }
  }

  function scrollToGuideToggle() {
    var mainRoot = document.querySelector('[data-guide-des-tailles-toggle].guide-des-tailles-toggle--main');
    if (!mainRoot) return;

    var headerOffset = 0;
    var stickyHeader = document.querySelector('.site-header');
    if (stickyHeader) {
      headerOffset = stickyHeader.offsetHeight || 0;
    }

    var top = mainRoot.getBoundingClientRect().top + window.pageYOffset - headerOffset - 8;
    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'auto'
    });
  }

  function setGender(gender, updateUrl, options) {
    if (gender !== 'homme' && gender !== 'femme') return;

    var previous = document.documentElement.getAttribute('data-guide-genre');
    document.documentElement.setAttribute('data-guide-genre', gender);
    document.body.setAttribute('data-guide-genre', gender);

    var root = document.querySelector('[data-guide-des-tailles-toggle].guide-des-tailles-toggle--main');
    var stickyRoot = document.querySelector('[data-guide-des-tailles-toggle-sticky]');

    syncToggleGroup(root, gender);
    syncToggleGroup(stickyRoot, gender);
    updateActiveStates();

    if (updateUrl !== false) {
      var params = new URLSearchParams(window.location.search);
      params.set('genre', gender);
      var query = params.toString();
      var newUrl = query ? window.location.pathname + '?' + query : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }

    var shouldResetScroll = options && options.resetScroll;
    if (shouldResetScroll === undefined) {
      shouldResetScroll = previous && previous !== gender;
    }

    if (shouldResetScroll) {
      scrollToGuideToggle();
    }

    window.requestAnimationFrame(function () {
      refreshGuideAnimations();
    });
  }

  function mountStickyToggle(stickyRoot) {
    if (!stickyRoot || stickyRoot.dataset.guideStickyMounted === 'true') return;
    stickyRoot.dataset.guideStickyMounted = 'true';

    if (stickyRoot.parentElement !== document.body) {
      document.body.appendChild(stickyRoot);
    }
  }

  function setupStickyToggle(mainRoot, stickyRoot) {
    if (!mainRoot || !stickyRoot) return;

    mountStickyToggle(stickyRoot);

    function setStickyVisible(isVisible) {
      stickyRoot.classList.toggle('is-visible', isVisible);
      stickyRoot.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
    }

    function updateStickyVisibility() {
      var rect = mainRoot.getBoundingClientRect();
      setStickyVisible(rect.bottom <= 0);
    }

    if (mainRoot.dataset.guideStickyObserved === 'true') {
      updateStickyVisibility();
      return;
    }

    mainRoot.dataset.guideStickyObserved = 'true';

    if ('IntersectionObserver' in window) {
      var stickyObserver = new IntersectionObserver(
        function (entries) {
          setStickyVisible(!entries[0].isIntersecting);
        },
        {
          threshold: 0,
          rootMargin: '0px'
        }
      );

      stickyObserver.observe(mainRoot);
    } else {
      window.addEventListener('scroll', updateStickyVisibility, { passive: true });
      window.addEventListener('resize', updateStickyVisibility);
      updateStickyVisibility();
    }
  }

  function bindToggleEvents(mainRoot, stickyRoot) {
    if (window.__guideDesTaillesToggleBound) return;
    window.__guideDesTaillesToggleBound = true;

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!input || input.type !== 'radio') return;
      if (!input.closest('.guide-des-tailles-toggle')) return;
      setGender(input.value);
    });

    document.addEventListener('click', function (event) {
      var option = event.target.closest('.guide-des-tailles-toggle__option');
      if (!option) return;

      var input = option.querySelector('input[type="radio"]');
      if (!input || input.disabled || !input.closest('.guide-des-tailles-toggle')) return;

      input.checked = true;
      setGender(input.value);
    });

    document.addEventListener('shopify:section:load', function () {
      initGuideDesTaillesToggle();
    });

    document.addEventListener('shopify:section:reorder', function () {
      initGuideDesTaillesToggle();
    });
  }

  function initGuideDesTaillesToggle() {
    var mainRoot = document.querySelector('[data-guide-des-tailles-toggle].guide-des-tailles-toggle--main');
    var stickyRoot = document.querySelector('[data-guide-des-tailles-toggle-sticky]');
    if (!mainRoot) return false;

    bindToggleEvents(mainRoot, stickyRoot);
    setGender(getInitialGender(), false, { resetScroll: false });
    setupStickyToggle(mainRoot, stickyRoot);
    refreshGuideAnimations();

    return true;
  }

  window.GuideDesTaillesToggle = {
    init: initGuideDesTaillesToggle
  };

  initGuideDesTaillesToggle();
  document.addEventListener('DOMContentLoaded', initGuideDesTaillesToggle);
  window.addEventListener('load', initGuideDesTaillesToggle);
})();
